import { PARTY_INVITATIONS, type PartyInvitations } from "./constants.ts";

/**
 * The values of "Party invitations" the game offers and its route accepts today (ADR-101 decision 6): `friends` and
 * `friendsOfFriends` are stored values but wait for the friend list, so they are neither offered nor accepted.
 */
export const PARTY_INVITATIONS_OFFERED = ["map", "nobody"] as const satisfies readonly PartyInvitations[];

/**
 * A value of the setting the game offers now.
 */
export type OfferedInvitation = (typeof PARTY_INVITATIONS_OFFERED)[number];

/**
 * Whether a value is one of the four stored values of the setting.
 *
 * @param value Anything.
 * @returns True when it is exactly `map`, `friends`, `friendsOfFriends` or `nobody`.
 */
export function isPartyInvitation(value: unknown): value is PartyInvitations {
  return typeof value === "string" && (PARTY_INVITATIONS as readonly string[]).includes(value);
}

/**
 * Whether a value is one the game offers and its route accepts now.
 *
 * @param value Anything.
 * @returns True when it is exactly `map` or `nobody`.
 */
export function isOfferedInvitation(value: unknown): value is OfferedInvitation {
  return typeof value === "string" && (PARTY_INVITATIONS_OFFERED as readonly string[]).includes(value);
}
